import { render, staticRenderFns } from "./FloatingMenu.vue?vue&type=template&id=5e358da0&scoped=true"
import script from "./FloatingMenu.vue?vue&type=script&lang=js"
export * from "./FloatingMenu.vue?vue&type=script&lang=js"
import style0 from "./FloatingMenu.vue?vue&type=style&index=0&id=5e358da0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e358da0",
  null
  
)

export default component.exports